module.exports = __webpack_public_path__ + "media/images/icons/shopping-bag-ecfab9745443fe6d87fb7745e956fe4d.svg";